import { render } from "./QuizCreateAccount.vue?vue&type=template&id=86b8c306"
import script from "./QuizCreateAccount.vue?vue&type=script&lang=js"
export * from "./QuizCreateAccount.vue?vue&type=script&lang=js"

import "./QuizCreateAccount.vue?vue&type=style&index=0&id=86b8c306&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__